<template>
  <div class="riskRelatedCard">
    <div class="riskRelatedCard_tit">
      {{ overviewName }}
      <el-tooltip class="item" effect="dark" content="" placement="top">
        <div slot="content">
          【指标定义】：<br />
          downlow 最大回撤是衡量一项投资在特定时期内从最高价格到最低价格<br />
          下跌幅度的指标。最大回撤为 0 意味着该投资在该时期内未出现价格下<br />
          跌，始终维持在最高水平；最大回撤大于 0 表明该投资在期间内有过价<br />
          格下跌，数值越大表示下跌幅度越大，投资的潜在亏损风险越高；对应<br />
          的选择天数表示，如选择 20 日，即计算截止到今天的交易日前的 20 日<br />
          期间内，该投资从最高价格到最低价格的最大下跌幅度。<br /><br />
          【计算公式】：<br />
          根据最大回撤的定义，其计算公式为：<br />
          最大回撤 =（期间内最高价格 - 期间内最低价格）/ 期间内最高价格<br />
          其中，期间内最高价格指的是在选定的时间段（如 20 日）中该投资所达<br />
          到的最高交易价格；期间内最低价格指的是在同一时间段中该投资所出<br />
          现的最低交易价格。<br />
          将选定时间段内的最高价格和最低价格代入公式，即可得到该时间段内<br />
          目标投资的 downlow 最大回撤值。
        </div>
        <i class="el-icon-question" style="color: rgb(64, 158, 255)"></i>
      </el-tooltip>
    </div>
    <div class="riskRelatedCard_ChooseArea">
      <div class="riskRelatedCard_ChooseArea_top">
        <span>
          显示类型
          <CButtonsSeparate
            @Cbtns_sep="fnGetCbtnsSep"
            class="CButtonsSeparate_style"
            :dButtons1="['大类', '个股']"
            v-bind.sync="btn1" />
        </span>
        <span v-show="btn1.dButtons1_current === '大类'">
          选择类别
          <CCascader
            key="大类"
            :default="da_lei_default_value"
            :multiple="true"
            :wide="true"
            :collapsetags="true"
            :checkStrictly="false"
            @CCascader_select_node="fnCCascader_select_val_chart3_1"
            :options="category_cascader_options">
          </CCascader>
        </span>
        <span v-show="btn1.dButtons1_current === '个股'">
          <CCascader
            key="个股"
            class="chart3_cascasder"
            :checkStrictly="false"
            :multiple="true"
            :isDelete="false"
            :wide="true"
            placeholder="请选择个股"
            :collapsetags="true"
            :default="reit_code_default"
            @CCascader_select_val="fnSelect_select_val_chart1_codename"
            :options="CODENAMEDATA"
            >选择个股
          </CCascader>
        </span>
        <span>
          <CSelect
            @CSelect_select_val="fnCSelect_chart1"
            :multiple="false"
            :clearable="false"
            :mini="true"
            v-bind.sync="select1"
            >选择类别</CSelect
          >
        </span>
        <span>
          <CSelect
            class="chart3_cascasder"
            @CSelect_select_val="change_time_options"
            :options="time_options"
            :clearable="false"
            :mini="true"
            :default="time_type">
            日期类型</CSelect
          >
        </span>
        <span>
          <CTimeButtons
            v-if="time_type == 'time_slot'"
            :spc1="'time_slot'"
            :default="btn3.dButtons1_current"
            @CTimeButtons_select_val="fnGetCbtnsSep2" />
          <CTimeButtons
            v-if="time_type == 'year'"
            :spc1="'year'"
            :default="btn3.dButtons1_current"
            @CTimeButtons_select_val="fnGetCbtnsSep2" />
          <div style="margin-left: 0px" v-if="time_type === '自定义'">
            <DateTimePick v-model="date_1" :clearable="false" @change="dateTimePickChange1" />
          </div>
        </span>
        <div class="downloadBtns">
          <CButtonsDownload
            :dButtonsDownloads="dButtonsDownloads"
            @fnButtondownload="fnButtonDL6_1" />
          <span style="display: none">
            <download-excel
              id="downloadExcel_downlow"
              :data="echart_data"
              :fields="json_fields"
              :name="overviewName">
              <i class="el-icon-download"></i>
            </download-excel>
          </span>
        </div>
      </div>
    </div>
    <div class="riskRelatedCard_content">
      <span @click="fnOpenDialog" class="iconfont icon-fangda icon-fangda2"></span>
      <div class="deadline_style ddl">数据截止日期：{{ chart_max_date }}<br /></div>
      <div
        class="downlow chartColumn1_style CHARTS_BGC"
        style="width: 100%; height: 450px"
        ref="downlowRef"
        v-loading="loading"
        element-loading-text="数据量巨大，正在计算中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 1)"></div>
    </div>
    <CDialog
      id="dialog1"
      ref="CDialog"
      :DIALOGHEIGHT="height_dialog"
      :dialogVisible="dialogVisible">
      <el-dialog
        title="葱花投研"
        :visible.sync="dialogVisible"
        :width="width_dialog"
        :top="top_dialog">
        <div>
          <el-dropdown size="mini" trigger="click" type="primary" @command="fnDropdown">
            <span class="el-dropdown-link">
              {{ popUpWindowDatas[popUpWindowIndex]
              }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="idx" v-for="(node, idx) in popUpWindowDatas" :key="idx">
                {{ node }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div :style="{ height: height_chart }">
          <div ref="downlowDialogRef" style="width: 100%; height: 100%"></div>
          <!-- <div class="Yield_Style">年化收益率</div> -->
          <!-- <div class="Volatility_Style">年化波动率</div> -->
        </div>
      </el-dialog>
    </CDialog>
  </div>
</template>

<script>
import CButtonsSeparate from '@/components/Basic/CButtons_separate';
import CSelect from '@/components/Basic/CSelect';
import CCascader from '@/components/Basic/CCascader';
import CTimeButtons from '@/components/Basic/CTimeButtons2';
import CButtonsDownload from '@/components/Basic/CButtons_download';
import CDialog from '@/components/Basic/CDialog';
import DateTimePick from '@/components/Basic/DateTimePick';

import html2canvas from 'html2canvas';
import { fnDownloadBgc } from '../../utils/util';

import { debounce, codesToNameMap2, categroyDefaultValue, getDateInfo } from '../../utils';

export default {
  name: 'Downlow',
  components: {
    CButtonsSeparate,
    CSelect,
    CCascader,
    CTimeButtons,
    CButtonsDownload,
    CDialog,
    DateTimePick,
  },
  data() {
    const CATEGORYDATA = JSON.parse(localStorage.getItem('CATEGORYDATA')) || [];
    const REITsNAME = JSON.parse(localStorage.getItem('REITsNAME2')) || [];
    const da_lei_default_value = categroyDefaultValue(CATEGORYDATA);
    const now = new Date();
    const today = new Date();
    today.setFullYear(today.getFullYear() - 1);
    return {
      date_1: [today, now],
      //
      time_options: Object.freeze([
        { label: '时间段', value: 'time_slot' },
        { label: '年份', value: 'year' },
        { label: '自定义', value: '自定义' },
      ]),
      time_type: 'time_slot',

      chart_max_date: '',
      dialogVisible: false,
      width_dialog: '80%',
      height_dialog: '73vh',
      height_chart: '72vh',
      popUpWindowDatas: this.$store.state.popUpWindowDatas,
      popUpWindowIndex: 0,
      top_dialog: '5vh',
      //

      sCurrentTheme: this.$store.state.theme == 'dark' ? true : false,
      overviewName: '最大回撤对比',
      json_fields: {},
      echart_data: [],
      sCurrentTheme: this.$store.state.theme == 'dark' ? true : false,
      loading: true,
      dButtonsDownloads: [
        {
          id: '241020',
          name: '下载图片',
        },
        {
          id: '241020',
          name: '下载表格',
        },
      ],
      CODENAMEDATA: Object.freeze(REITsNAME),
      // 个股
      reit_code_default: codesToNameMap2(REITsNAME),
      // days: Object.freeze(['YTD', '3M', '6M', '1Y', '3Y', 'MAX']),
      // 类型
      // single type
      btn1: {
        disabled: false,
        dButtons1_current: '大类',
      },
      btn3: {
        disabled: false,
        dButtons1_current: 'YTD',
      },
      // 大类
      category_cascader_options: Object.freeze(CATEGORYDATA),
      da_lei_default_value: Object.freeze(da_lei_default_value),
      da_lei_value: [...new Set(da_lei_default_value.flat(1))],
      // 类别
      select1: {
        default: 'downlow',
        options: [
          {
            label: '最大回撤',
            value: 'downlow',
          },
          {
            label: '年化波动率',
            value: 'risk_ann',
          },
        ],
      },
      ROOTFONTFIZE: '',
      colors: {},
    };
  },
  computed: {
    currentTheme() {
      return this.$store.state.theme; // 从Vuex中获取当前的主题值
    },
  },
  watch: {
    currentTheme(newVal, oldVal) {
      this.fnGetTheme();
      this.renderEchart(this.echart_data);
    },
  },
  methods: {
    dateTimePickChange1() {
      this.loadingData();
    },
    change_time_options(val) {
      this.time_type = val;
      if (this.time_type == 'time_slot') {
        this.btn3.dButtons1_current = 'YTD';
      } else if (val === '自定义') {
        this.btn3.dButtons1_current = val;
      } else {
        this.btn3.dButtons1_current = '2021';
      }
      setTimeout(() => {
        this.dateTimePickChange1();
      }, 0);
    },
    fnOpenDialog() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.renderEchart(this.echart_data, true);
      });
    },
    fnDropdown(val) {
      let conf = this.$store.state.popUpWindowConfi[val];
      this.width_dialog = conf.width_dialog;
      this.top_dialog = conf.top_dialog;
      this.height_dialog = conf.height_dialog;
      this.popUpWindowIndex = val;
      this.height_chart = conf.height_chart;
      this.$nextTick(() => {
        this.renderEchart(this.echart_data, true);
      });
    },
    fnButtonDL6_1(val) {
      if (val == '下载图片') {
        this.fnButtonDL6_4_1();
      } else {
        setTimeout(() => {
          document.getElementById('downloadExcel_downlow').click();
        }, 0);
      }
    },
    //下载图片
    fnButtonDL6_4_1() {
      let h = this.$refs.downlowRef.scrollHeight;
      let w = this.$refs.downlowRef.scrollWidth;
      // 第一个参数是需要生成截图的元素,第二个是自己需要配置的参数,宽高等
      html2canvas(this.$refs.downlowRef, {
        height: h + 20,
        width: w,
        backgroundColor: fnDownloadBgc(this.sCurrentTheme),
        useCORS: true,
        scale: 1,
      }).then((canvas) => {
        let url = canvas.toDataURL('image/png');
        var a = document.createElement('a'); // 生成一个a元素
        var event = new MouseEvent('click'); // 创建一个单击事件
        a.download = this.overviewName; // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      });
    },
    // 表格数据
    tabelData() {
      const is_single = this.btn1.dButtons1_current === '个股';
      const type = this.select1.default;
      const json_fields = {
        category: 'category_2',
        name: 'name',
        reit_code: 'reit_code',
      };
      if (!is_single) {
        json_fields.category = 'category';
        delete json_fields.name;
        delete json_fields.reit_code;
      }
      if (type === 'risk_ann') {
        json_fields['年化波动率'] = {
          field: 'time_period',
          callback: (v = 0) => {
            return (v * 100).toFixed(2) + '%';
          },
        };
      } else if (type === 'downlow') {
        json_fields['最大回撤比'] = {
          field: 'time_period',
          callback: (v = 0) => {
            return (v * 100).toFixed(2) + '%';
          },
        };
      }
      this.json_fields = json_fields;
    },
    fnGetTheme() {
      this.sCurrentTheme = this.$store.state.theme == 'dark' ? true : false;
    },
    loadingData: debounce(function () {
      this.$nextTick(this._loadingData);
    }, 500),
    async _loadingData() {
      this.loading = true;
      const is_single = this.btn1.dButtons1_current === '个股';
      const queryString = new URLSearchParams({
        factor: this.select1.default,
        cal_function: is_single ? 'single' : 'type',
      }).toString();
      const r_type = this.da_lei_value.join('&r_type=');
      const codes = !is_single ? '' : this.reit_code.join('&codes=');

      let start_date = this.btn3.dButtons1_current;
      const end_date = start_date === '自定义' ? getDateInfo(this.date_1[1]).dateString : '';
      const v = start_date === '自定义' ? 'v2_5/' : 'v2/';
      let qs = `${queryString}&r_type=${r_type}&codes=${codes}`;
      if (start_date === '自定义') {
        start_date = getDateInfo(this.date_1[0]).dateString;
        qs += `&start_date=${start_date}&end_date=${end_date}`;
      } else {
        qs += `&days=${start_date}`;
      }

      const { data } = await this.$https.get('/api/' + v + 'get_downlow_data?' + qs);
      this.loading = false;
      if (data.code !== 200) return this.$message.error(data.msg);
      let echart_data = data.data || [];
      this.data_avg = data.avg;
      this.chart_max_date = data.max_end_date || '';
      echart_data = echart_data.filter((item) => item.time_period);
      echart_data.sort((a, b) => b.time_period - a.time_period);
      this.echart_data = echart_data;
      this.renderEchart(echart_data);
      this.$nextTick(() => {
        this.tabelData();
      });
    },
    renderEchart(echart_data, flag) {
      if (flag) {
        if (!this.echart_dialog_instance) {
          this.echart_dialog_instance = this.$echarts.init(this.$refs.downlowDialogRef);
        }
        this.echart_dialog_instance.clear();
      }
      if (!this.echart_instance) {
        this.echart_instance = this.$echarts.init(this.$refs.downlowRef);
      }
      !flag && this.echart_instance.clear();

      // 颜色数组 不正确的数据结构浪费时间和性能
      const colors = this.$store.state.colors || [];
      this.colors = colors.reduce((p, c) => {
        p[c.name] = c.value;
        return p;
      }, {});

      let OPTIONDATA =
        this.$store.state.theme == 'dark'
          ? this.$store.state.OPTIONDATA
          : this.$store.state.OPTIONDATA_light;
      const is_single = this.btn1.dButtons1_current === '个股';
      const x_name = is_single ? 'name' : 'category';

      const colorArr = echart_data.map((item) => {
        return this.colors[item.category_2 || item.category];
      });
      const theme = this.$store.state.theme;

      const item_length = (echart_data || []).length || 40;
      const font_r = item_length > 40 ? 40 / item_length : 1;

      let line_lebel_name = '最大回撤';
      if (this.select1.default === 'risk_ann') {
        line_lebel_name = '年化波动率';
      }
      const options = {
        color: colorArr,
        dataset: [
          {
            dimensions: ['category_2', 'category', 'index', 'name', 'reit_code', 'time_period'],
            source: echart_data,
          },
        ],
        xAxis: {
          type: 'category',
          axisLabel: {
            interval: 0,
            rotate: flag && this.popUpWindowIndex === 1 ? 50 : 35,
            margin: OPTIONDATA.xAxis.axisLabel.margin,
            fontSize: OPTIONDATA.xAxis.axisLabel.fontSize * font_r,
            showMaxLabel: true,
            color: OPTIONDATA.xAxis.axisLabel.color,
          },
        },
        yAxis: {
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            fontSize: OPTIONDATA.yAxis.axisLabel.fontSize,
            show: true,
            color: OPTIONDATA.yAxis.axisLabel.color,
            formatter: function (args) {
              args = Number(args * 100).toFixed(2) + '%';
              return args;
            },
          },
          splitLine: OPTIONDATA.yAxis.splitLine,
        },
        tooltip: {
          trigger: 'axis',
          confine: true,
          triggerOn: 'mousemove|click',
          formatter: (data) => {
            const item = data[0] || {};
            return `${item.name}: <span style="margin-left:6px">${(
              item.data.time_period * 100
            ).toFixed(2)}%</span>`;
          },
        },
        series: {
          type: 'bar',
          encode: { x: x_name, y: 'time_period' },
          colorBy: 'data',
          // 平均线
          markLine: {
            symbol: ['none', 'none'],
            precision: 5,
            data: [
              {
                // type: 'average',
                yAxis: this.data_avg,
              },
            ],
            silent: true,
            lineStyle: {
              type: 'dotted',
              color: theme == 'dark' ? '#fff' : '#878787',
              width: 2,
            },
            label: {
              color: theme == 'dark' ? '#b6b6b6' : '#5a4f4f',
              position: 'insideEndTop',
              fontSize: 14,
              formatter: () => {
                return `{title|${is_single ? '个股' : '大类'}平均${line_lebel_name}: }  {value|${(
                  this.data_avg * 100
                ).toFixed(2)}%} `;
              },
              rich: {
                title: {
                  color: OPTIONDATA.legend.textStyle.color,
                  fontSize: 14,
                },
                value: {
                  color: '#fff',
                  color: OPTIONDATA.xAxis.axisLabel.color,
                  fontSize: 16,
                  fontWeight: 'bolder',
                },
              },
            },
          },
          label: {
            show: true,
            position: 'top',
            fontSize: 14 * font_r,
            color: OPTIONDATA.legend.textStyle.color,
            formatter: ({ data }) => {
              return `${(data.time_period * 100).toFixed(2)}%`;
            },
          },
        },
        // 四个方向的空白
        grid: {
          top: this.ROOTFONTFIZE * (60 / 144),
          left: this.ROOTFONTFIZE * (35 / 144),
          right: this.ROOTFONTFIZE * (60 / 144),
          bottom: this.ROOTFONTFIZE * (30 / 144),
          containLabel: true,
        },
      };
      if (flag) {
        this.echart_dialog_instance.setOption(options);
        this.echart_dialog_instance.resize();
        return;
      }
      this.echart_instance.setOption(options);
      this.echart_instance.resize();
    },
    // 选择大类
    fnCCascader_select_val_chart3_1(val) {
      this.da_lei_value = val;
      this.loadingData();
    },
    // 选择个股
    fnSelect_select_val_chart1_codename(val) {
      const data = val.filter((node) => {
        return node.includes('.');
      });
      this.reit_code = data;
      this.loadingData();
    },
    // 选择类别
    fnCSelect_chart1(val) {
      if (val === 'downlow') {
        this.overviewName = '最大回撤比';
      } else if (val === 'risk_ann') {
        this.overviewName = '年化波动率';
      }
      this.select1.default = val;
      this.loadingData();
    },
    // 选择类型
    fnGetCbtnsSep(val) {
      this.btn1.dButtons1_current = val;
      this.loadingData();
    },
    // 选择时间
    fnGetCbtnsSep2(val) {
      this.btn3.dButtons1_current = val;
      this.loadingData();
    },
    // 获取当前屏幕宽度
    fnGetWidth() {
      var element = document.getElementById('rootchart');
      let ROOTFONTFIZE = element.offsetWidth;
      ROOTFONTFIZE = ROOTFONTFIZE > 1440 ? 1440 : ROOTFONTFIZE;
      ROOTFONTFIZE = ROOTFONTFIZE < 1400 ? ROOTFONTFIZE - 200 : ROOTFONTFIZE;
      this.ROOTFONTFIZE = ROOTFONTFIZE / 10;
      return;
    },
    resize() {
      this.fnGetWidth();
      this.echart_instance && this.echart_instance.resize();
    },
  },
  created() {
    // 默认值（组件封装太垃圾，手动处理）
    this.reit_code = this.reit_code_default
      .map((item) => {
        return item.find((n) => n.indexOf('.') >= 0);
      })
      .filter((item) => item);
  },
  mounted() {
    this.resize();
    window.addEventListener('resize', this.resize);
    this.$nextTick(() => {
      this.loadingData();
    });
  },
  beforeDestroy() {
    this.echart_instance && this.echart_instance.dispose();
    this.echart_dialog_instance && this.echart_dialog_instance.dispose();
    window.removeEventListener('resize', this.resize);
  },
};
</script>

<style scoped lang="less">
.ddl {
  position: absolute;
  z-index: 5;
  left: calc(var(--ROOTFONTFIZE) * (50 / 144));
  bottom: calc(var(--ROOTFONTFIZE) * (10 / 144));
  color: #fff;
  font-size: calc(var(--ROOTFONTFIZE) * (14 / 144));
  span {
    font-size: calc(var(--ROOTFONTFIZE) * (12 / 144));
  }
}

.icon-fangda2 {
  right: 30px;
}

.downloadBtns {
  margin-right: 0;
  margin-left: auto;
}

.CButtonsSeparate_style {
  // margin-left: calc(var(--ROOTFONTFIZE) * (20 / 144));
  margin-left: 20px;
}
.riskRelatedCard_ChooseArea_top span,
.riskRelatedCard_ChooseArea_bottom span {
  // flex: 1;
  // min-width: 20%;
  // flex: 1;
  display: flex;
  align-items: center;
  color: var(--stock_area_item_color1);
  margin-right: calc(var(--ROOTFONTFIZE) * (30 / 144));
  font-size: calc(var(--ROOTFONTFIZE) * (14 / 144));
}
.riskRelatedCard {
  background-color: rgba(29, 31, 37, 1);
  background-color: var(--charts_bgc);
  border-radius: calc(var(--ROOTFONTFIZE) * (20 / 144));
  padding-top: calc(var(--ROOTFONTFIZE) * (15 / 144));
  margin-bottom: calc(var(--ROOTFONTFIZE) * (20 / 144));
  padding-bottom: calc(var(--ROOTFONTFIZE) * (20 / 144));
  height: auto;
}

.riskRelatedCard_tit {
  padding-left: calc(var(--ROOTFONTFIZE) * (18 / 144));
  font-size: calc(var(--ROOTFONTFIZE) * (22 / 144));
  font-weight: 700;
  letter-spacing: 0px;
  line-height: calc(var(--ROOTFONTFIZE) * (28 / 144));
  color: var(--chart_title);
  // border-left: 5px solid rgba(21, 115, 254, 1);
  border-left: calc(var(--ROOTFONTFIZE) * (5 / 144)) solid var(--primary-color);
}
.riskRelatedCard_content {
  position: relative;
  padding: 0 calc(var(--ROOTFONTFIZE) * (15 / 144));
}
.chartColumn1_style {
  margin-top: calc(var(--ROOTFONTFIZE) * (20 / 144));
  border-radius: calc(var(--ROOTFONTFIZE) * (10 / 144));
}
.riskRelatedCard_ChooseArea_top {
  margin-top: calc(var(--ROOTFONTFIZE) * (20 / 144));
  margin-bottom: calc(var(--ROOTFONTFIZE) * (30 / 144));
  padding-left: calc(var(--ROOTFONTFIZE) * (20 / 144));
  padding-right: calc(var(--ROOTFONTFIZE) * (20 / 144));
  display: flex;
}
</style>
